import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AppShell } from "@/components/AppShell";
import { useAuth } from "@/context/AuthContext";
import { updateProfile } from "@/api";

export default function ProfilePage() {
  const { user, refreshUser } = useAuth();
  const [username, setUsername] = useState(user?.username || "");
  const [status, setStatus] = useState("");

  const handleUpdate = async (event) => {
    event.preventDefault();
    setStatus("");
    try {
      await updateProfile({ username });
      await refreshUser();
      setStatus("Your title has been reforged.");
    } catch (error) {
      setStatus("Unable to update your profile.");
    }
  };

  return (
    <AppShell>
      <section className="space-y-6" data-testid="profile-page">
        <div data-testid="profile-header">
          <p className="text-xs uppercase tracking-[0.4em] text-stone-500" data-testid="profile-eyebrow">
            Account
          </p>
          <h1 className="font-cinzel text-3xl" data-testid="profile-title">
            Bound Identity
          </h1>
          <p className="text-stone-400" data-testid="profile-description">
            Update the name your party sees inside the war rooms.
          </p>
        </div>

        <form className="panel-iron rounded-xl p-8 space-y-4 max-w-xl" onSubmit={handleUpdate} data-testid="profile-form">
          <label className="text-stone-300 text-sm" htmlFor="profile-username" data-testid="profile-username-label">
            Display Name
          </label>
          <Input
            id="profile-username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            className="bg-stone-950 border-stone-800 text-stone-200"
            data-testid="profile-username-input"
          />
          <p className="text-stone-500 text-sm" data-testid="profile-email">
            Signed in as {user?.email}
          </p>
          {status && (
            <div className="bg-red-900/30 border border-red-900/50 text-red-200 px-4 py-3 rounded-lg" data-testid="profile-status">
              {status}
            </div>
          )}
          <Button
            type="submit"
            className="bg-red-900 hover:bg-red-800 text-stone-100 font-cinzel uppercase tracking-[0.25em]"
            data-testid="profile-submit-button"
          >
            Update Name
          </Button>
        </form>
      </section>
    </AppShell>
  );
}
